import { clone } from 'ramda';
import { EFiltersActionType } from '../actions/filters';
import { EFiltersMetaStatus, IFiltersState } from '../types/filters';
import { TReduxActions } from '../types/redux';

const defaultState: IFiltersState = {
  appliedFilters: {},
  savedFilters: {},
  meta: {
    status: EFiltersMetaStatus.Initial,
  },
};

export const filtersReducer = (state: IFiltersState = defaultState, action: TReduxActions): IFiltersState => {
  switch (action.type) {
    case EFiltersActionType.StartFetchingMeta:
      return {
        ...state,
        meta: {
          ...state.meta,
          status: EFiltersMetaStatus.Pending,
        },
      };

    case EFiltersActionType.SetMeta:
      return {
        ...state,
        meta: action.payload,
      };

    case EFiltersActionType.SetSavedFilters:
      return {
        ...state,
        savedFilters: {
          ...state.savedFilters,
          ...action.payload,
        },
      };

    case EFiltersActionType.ReplaceSavedFilters:
      return {
        ...state,
        savedFilters: {
          ...action.payload,
        },
      };

    case EFiltersActionType.MergeFilters:
      return {
        ...state,
        appliedFilters: clone(state.savedFilters),
      };

    case EFiltersActionType.SetOpenedFilter:
      return {
        ...state,
        openedFilter: action.payload,
      };

    case EFiltersActionType.SetTooltipTarget:
      return {
        ...state,
        tooltipTarget: action.payload,
      };

    case EFiltersActionType.SetFiltersPosition:
      return {
        ...state,
        position: action.payload,
      };

    default:
      return state;
  }
};
